<template>
    <div class="hts-distributing">
        <div class="absolute top-5 left-5 z-[9999]">
            <div
                v-if="!showJourey"
                class="flex gap-1 rotate-90 items-center cursor-pointer bg-gray-100 hover:bg-gray-200 translate-y-10 translate-x-[-42px] mt-2 ml-1 font-bold box-border rounded"
                @click="handleShowJourey">
                <hi-chevron-double-left-icon class="h-5 w-5 rotate-90" />
                <p>
                    Chặng hàng
                </p>
            </div>
        </div>
        <div
            class="hts-distributing-list hts-distributing__list flex flex-col transition-all w-[460px]"
            :class="{ hidden: !showJourey, flex: showJourey }">
            <div class="hts-distributing__sidebar header box-border p-2 pr-1">
                <hts-map-icon-journey class="float-right" />
                <h3>
                    Danh sách chặng cần điều phối:
                </h3>
                <div>
                    <div class="flex flex-wrap justify-between">
                        <div>
                            Lần điều phối kế tiếp vào lúc:
                        </div>
                        <div class="font-bold">
                            {{ $formatters.datetime(nextScheduleDatetime.valueOf()) }}
                        </div>
                    </div>
                    <div class="flex flex-wrap justify-between">
                        <div>
                            Tự động xác nhận điều phối sau:
                        </div>
                        <div class="font-bold text-error-500">
                            {{ $formatters.datetime(nextScheduleConfirmDatetime.valueOf()) }}
                        </div>
                    </div>
                </div>
                <div class="flex w-full items-center gap-4">
                    <div class="flex-1 space-y-2">
                        <div class="flex justify-start align-middle items-center gap-1 transition-all">
                            <input
                                v-model="checkAll"
                                :disabled="!journeyTabsShowCheckAll.includes(journeyStatusViewing)"
                                type="checkbox"
                                class="w-6 h-6" ><span>
                                    Tất cả
                                </span>
                        </div>
                    </div>
                    <div class="flex-initial flex items-center gap-4">
                        <hts-form-button
                            color="primary"
                            :outline="false"
                            @click="handleManualSchedule">
                            Điều xe thủ công
                        </hts-form-button>

                        <hts-form-button
                            color="primary"
                            :outline="false"
                            @click="openScheduleInfo">
                            Điều xe tự động
                        </hts-form-button>
                    </div>
                </div>
                <hts-form-input
                    v-model="journeyFilters.search"
                    class="flex-initial w-full mt-2"
                    :placeholder="$t('labels.findJourney')">
                    <template #prefix>
                        <hi-magnifying-glass-icon class="h-6 w-6 ml-2 text-gray-500" />
                    </template>
                </hts-form-input>
            </div>

            <div class="hts-distributing-list__content flex-1 mt-2 overflow-hidden content pb-12">
                <hts-ui-tabs
                    v-model="journeyStatusViewing"
                    :tabs="journeyTabs"
                    size="small" />

                <journey-list
                    ref="journeyListComponent"
                    v-model:selected="selectedJourneys"
                    :items="journeys"
                    :loading="journeyLoading"
                    @click="selectJourney">
                    <template #actions="{ item, hover }">
                        <div class="flex-initial flex flex-col justify-center items-center p-2 text-right max-w-[100px]">
                            <span
                                class="text-base select-none cursor-pointer text-info-500 hover:text-info-600 underline"
                                @click="openJourney(item)">
                                Xem chi tiết
                            </span>
                            <div
                                v-if="item.status === 4"
                                class="relative mt-2 rounded border border-green-500 text-green-500 px-1 text-left">
                                <span>
                                    {{ item.vehicleLicensePlate }}
                                </span>
                            </div>
                            <div
                                v-else-if="item.status === 3"
                                class="relative mt-2 rounded border border-orange-500 text-orange-500 px-1 text-left">
                                <span>
                                    Xe dự kiến: {{ item.vehicleLicensePlate }}
                                </span>
                            </div>
                            <div
                                v-else-if="item.status === 2"
                                class="relative mt-2 rounded border border-blue-500 text-blue-500 px-1 text-left">
                                <span>
                                    Chờ điều xe
                                </span>
                            </div>

                            <!--
                              <hts-form-button
                              v-if="!item.vehicleId"
                              class="flex-initial mt-2"
                              :class="{ invisible: !hover }"
                              color="info"
                              type="button"
                              size="small"
                              :outline="false"
                              @click="handleManualSchedule()">
                              <span
                              v-if="item.vehicleTempId"
                              class="text-sm whitespace-nowrap">
                              Chọn xe
                              </span>
                              <span
                              v-else
                              class="text-sm whitespace-nowrap">
                              Chọn xe dự kiến
                              </span>
                              </hts-form-button>
                            -->
                        </div>
                    </template>
                </journey-list>
            </div>
        </div>

        <div class="hts-distributing__detail a">
            <journey-schedule
                ref="journeyScheduleComponent"
                @change="refresh" />
        </div>

        <!-- Dialogs -->
        <schedule-settings ref="scheduleSettingComponent" />
        <schedule-info
            ref="scheduleInfoComponent"
            @change="handleScheduleChange" />
        <journey-info
            ref="journeyInfoComponent"
            :api="$url.journey.get"
            :exclude="['plan-actual', 'alerts', 'driver-notifications', 'time-and-jobs', 'prices', 'activities']" />

        <hts-modal
            v-model="showManualSchedule"
            size="small"
            title="Cảnh báo điều xe thủ công"
            @close="() => (showManualSchedule = false)">
            <div class="flex items-center text-lg">
                <p>
                    {{ manualScheduleError }}
                </p>
            </div>
        </hts-modal>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import JourneyInfo from '../-components/journey-info.vue'
import JourneyList from './-components/journey-list.vue'
import JourneySchedule from './-components/journey-schedule.vue'
import ScheduleSettings from './-components/schedule-settings.vue'
import ScheduleInfo from './-components/schedule-info.vue'

const { $dayjs, $event, $formatters } = useNuxtApp()
const { system, distributingPage, map } = $store()
const route = useRoute()
const router = useRouter()
const checkAll = ref(false)
const journeyFilters = computed({
  get: () => distributingPage.journeyFilters,
  set: (val: any) => {
    distributingPage.setJourneyFilters(val)
  }
})
const showJourey = computed(() => {
  return map.getShowJourney
})

const handleShowJourey = () => {
  const { map } = $store()
  map.setShowJourney(true)
}

onBeforeMount(() => {
  map.setShowLocation({ distributing: false })
  map.setShowMap({ distributing: true })
})

const journeyLoading = ref(true)
const journeys = ref<any[]>([])
const journeyLength = computed(() => journeys.value.length)
const selectedJourneys = ref<any[]>([])
const selected = computed(() => selectedJourneys.value.length > 0)
const journeyStatusViewing = ref('ALL')
const showManualSchedule = ref(false)

const firstSelectedJourney = computed(() => {
  if (!Array.isArray(selectedJourneys.value)) {
    return null
  }
  const selectId = selectedJourneys.value?.[0] || null

  const journey = journeys.value.filter((val: any) => {
    return val._id === selectId
  })

  return journey?.[0] || null
})

const manualScheduleError = ref('')
const now = computed(() => $dayjs())

const getHourAndMin = (val: number) => {
  const hour = parseInt(val.toString()).toString()
  const min = parseInt(Math.round((val - Math.floor(val)) * 60).toString(), 10).toString()
  return { hour, min }
}

const nextScheduleDatetime = computed(() => {
  const startTime = getHourAndMin(system.scheduleSettings.start)
  const endTime = getHourAndMin(system.scheduleSettings.end)
  const startDatetime = $dayjs().hour(startTime.hour).minute(startTime.min).second(0)
  const endDatetime = $dayjs().hour(endTime.hour).minute(endTime.min).second(0)
  if (now.value < startDatetime) {
    return startDatetime
  }
  if (now.value < endDatetime) {
    return endDatetime
  }
  return startDatetime.add(1, 'day')
})

const nextScheduleConfirmDatetime = computed(() => {
  return nextScheduleDatetime.value.add(system.scheduleSettings.confirmationTime, 'm')
})

onMounted(() => {
  automationActions()
  getJourneys()
  $event.listen(`c-${company.value._id}-journey-schedule-change`, (data: any) => {
    setDataScheduleChange(data)
  })
  $event.listen(`c-${company.value._id}-change-vehicle-change-ready`, (data: any) => {
    setDataVehicleChange(data)
  })
})

const action = computed(() => route.query.action)
watch(
  () => action.value,
  () => automationActions()
)

const automationActions = () => {
  const action = route.query.action || ''
  switch (action) {
  case 'open-schedule':
    openScheduleInfo()
    break
  }
  nextTick(() => {
    router.replace({ query: { action: undefined } })
  })
}

watch(
  () => checkAll.value,
  (val: boolean) => {
    handleCheckAll(val)
  }
)

watch(
  () => journeyStatusViewing.value,
  (val: string) => {
    refresh()
  }
)

watch(
  () => journeyFilters.value.search,
  (val: string) => {
    refresh()
  }
)

const refresh = $lodash.debounce(() => {
  journeys.value = []
  checkAll.value = false
  selectedJourneys.value = []
  getJourneys()
}, 500)

const getJourneys = () => {
  journeyLoading.value = true
  $api($url.journey.getJourneys, {
    query: {
      skip: journeyLength.value,
      type: journeyStatusViewing.value,
      search: journeyFilters.value.search
    }
  })
    .then(({ data }: any) => {
      const temp = (data?.value || {}).data || []
      if (Array.isArray(temp)) {
        journeys.value = [...journeys.value, ...temp]
      }
      journeyLoading.value = false
    })
    .catch(() => {
      journeyLoading.value = false
    })
}

const journeyScheduleComponent: any = ref(null)
const scheduleInfoComponent: any = ref(null)
const openScheduleInfo = () => {
  if (selectedJourneys.value.length) {
    return scheduleInfoComponent.value && scheduleInfoComponent.value.show(selectedJourneys.value)
  }
  scheduleInfoComponent.value && scheduleInfoComponent.value.show()
}
const scheduleSettingComponent: any = ref(null)
const openScheduleSetting = () => {
  scheduleSettingComponent.value && scheduleSettingComponent.value.show()
}

const journeyInfoComponent: any = ref(null)
const selectJourney = (journey: any) => {
  journeyScheduleComponent.value && journeyScheduleComponent.value.selectJourney(journey)
}
const openJourney = (journey: any) => {
  selectJourney(journey)
  journeyInfoComponent.value && journeyInfoComponent.value.show(journey._id)
}

const journeyListComponent: any = ref(null)
const handleCheckAll = (val: boolean) => {
  journeyListComponent.value && journeyListComponent.value.checkAll(val)
}

const company = computed(() => $store().system.getCompany)

const setDataVehicleChange = (data: { [key: string]: any }) => {
  journeyScheduleComponent.value.addRow(data.message)
}

const setDataScheduleChange = (data: { [key: string]: any }) => {
  try {
    const tempData = data.message || {}
    const rowId = journeyScheduleComponent.value.getRowById(tempData.data.vehicle._id)
    switch (tempData.type) {
    case 'create':
      if (rowId) {
        journeyScheduleComponent.value.updateAndAddItem(tempData.data.vehicle._id, tempData.data.journey)
      }
      break
    case 'update':
      if (rowId) {
        journeyScheduleComponent.value.updateAndAddItem(tempData.data.vehicle._id, tempData.data.journey)
      }
      break
    case 'delete':
      journeyScheduleComponent.value.deleteItem(tempData.data)
      break
    default:
      return null
    }
  } catch (e: any) {}
}

const handleScheduleChange = (journeys: any[]) => {
  journeyScheduleComponent.value.addItems(journeys)

  refresh()
}

onUnmounted(() => {
  $event.unsubscribe(`c-${company.value._id}-journey-schedule-change`, () => {})
  $event.unsubscribe(`c-${company.value._id}-change-vehicle-change-ready`, () => {})
})

const handleManualSchedule = () => {
  if (!Array.isArray(selectedJourneys.value) || !selectedJourneys.value.length) {
    showManualSchedule.value = true
    manualScheduleError.value = 'Vui lòng chọn 1 chặng để điều thủ công'
    return
  }

  if (selectedJourneys.value.length > 1) {
    manualScheduleError.value = 'Vui lòng chọn 1 chặng để điều thủ công'
    showManualSchedule.value = true
    return
  }

  if (!firstSelectedJourney.value) {
    manualScheduleError.value = 'Vui lòng chọn 1 chặng để điều thủ công'
    showManualSchedule.value = true
    return ''
  }

  // if (firstSelectedJourney.value.vehicleStatus === 1) {
  //   manualScheduleError.value = `Chặng ${firstSelectedJourney.value.code} đã được điều xe chính thức`
  //   showManualSchedule.value = true
  //   return ''
  // }

  showManualSchedule.value = false
  journeyScheduleComponent.value && journeyScheduleComponent.value.manualSchedule(firstSelectedJourney.value)
}

const journeyTabs = [
  {
    key: 'ALL',
    label: 'Tất cả'
  },
  {
    key: 'NotYetDistribution',
    label: 'Chưa điều'
  },
  {
    key: 'ScheduleDistribution',
    label: 'Điều dự kiến'
  },
  {
    key: 'ConfirmedDistribution',
    label: 'Điều chính thức'
  }
]

// create hello work func

const journeyTabsShowCheckAll = ['NotYetDistribution', 'ScheduleDistribution']
</script>
